import {NgModule} from '@angular/core';
import {RouterModule, Routes, UrlSegment} from '@angular/router';
import {AuthGuard} from './appSharedModule/guards/auth-guard.service';
import {PageNotFoundComponent} from './components/page-not-found/page-not-found.component';
import {BwSchedulesComponent} from './components/bw-schedules/bw-schedules.component';
import {BwEtreeOverviewComponent} from './components/bw-etree-overview/bw-etree-overview.component';
import {QuincyEtreesListComponent} from './components/quincy-etrees-list/quincy-etrees-list.component';
import {ClfLedgerComponent} from './components/clf-ledger/clf-ledger.component';
import {QuincyEtreeOverViewComponent} from './components/quincy-etree-over-view/quincy-etree-over-view.component';
import {QedSymbolDataComponent} from './components/qed-symbol-data/qed-symbol-data.component';
import {PopTrigramComponent} from './components/commercial-pops/pop-trigram/pop-trigram.component';
import {QedMulticastListComponent} from './components/qed-multicast-list/qed-multicast-list.component';
import {QrdSymbolDataComponent} from './components/qrd-symbol-data/qrd-symbol-data.component';
import {QrdMulticastListComponent} from './components/qrd-multicast-list/qrd-multicast-list.component';
import {QrdProductInformationComponent} from './components/qrd-product-information/qrd-product-information.component';
import {HomeComponent} from './components/home/home.component';
import {ImpersonateUserComponent} from './components/impersonate-user/impersonate-user.component';
import {DownloadLogComponent} from './components/download-log/download-log.component';
import {LoaComponent} from './components/loa/loa.component';
import {WeatherMapComponent} from './components/weather-map/weather-map.component';
import {DocumentCrudComponent} from './components/document-crud/document-crud.component';
import {DocumentsComponent} from './components/documents/documents.component';
import {ChangePasswordComponent} from './components/change-password/change-password.component';
import {ResetPasswordComponent} from './components/reset-password/reset-password.component';
import {
  EmailChangeConfirmationComponent
} from './components/email-change-confirmation/email-change-confirmation.component';
import {
  RequestHistoricalDataComponent
} from './components/historical-data/request-historical-data/request-historical-data.component';
import {ListUsersComponent} from './components/list-user/list-user.component';
import {ListClientsComponent} from './components/list-clients/list-clients.component';
import {UserCrudComponent} from './components/user-crud/user-crud.component';
import {ClientCrudComponent} from './components/client-crud/client-crud.component';
import {DocumentNotificationComponent} from './components/document-notification/document-notification.component';
import {DownloadDocumentComponent} from './components/download-document/download-document.component';
import {ListExchangesComponent} from './dad-reporting/components/list-exchanges/list-exchanges.component';
import {DadConfigCrudComponent} from './dad-reporting/components/dad-config-crud/dad-config-crud.component';
import {ListReportersComponent} from './dad-reporting/components/list-reporters-component/list-reporters.component';
import {EncryptionKeysComponent} from './components/encryption-keys/encryption-keys.component';
import {EncryptionKeysLogsComponent} from './components/encryption-keys-logs/encryption-keys-logs.component';
import {QedProfileComponent} from './components/qed-profile/qed-profile.component';
import {DadAdminComponent} from './dad-reporting/components/dad-admin-page/dad-admin/dad-admin.component';
import {DadFormComponent} from './dad-reporting/components/dad-forms/dad-form/dad-form.component';
import {AnnouncementLogComponent} from './components/announcement-log/announcement-log.component';
import {ListRecipientsComponent} from './components/list-recipients/list-recipients.component';
import {AdminEncryptionKeysComponent} from './components/admin-encryption-keys/admin-encryption-keys.component';
import {BwGraphListComponent} from './components/bw-graph/bw-graph-list/bw-graph-list.component';
import {
  HistoricalDataRequestLogComponent
} from './components/historical-data/historical-data-request-log/historical-data-request-log.component';
import {EtreesCountersLiveComponent} from './components/etrees-counters-live/etrees-counters-live.component';
import {CountersMqttComponent} from './components/counters-mqtt/counters-mqtt.component';
import {SymbolDataDownloadLogComponent} from './components/symbol-data-download-log/symbol-data-download-log.component';
import {WorkVisitCrudComponent} from './hosting-manager/components/work-visit/crud/work-visit-crud.component';
import {UnsavedChangesGuard} from './appSharedModule/guards/unsaved-changes-guard.service';
import {BwGraphEndToEndComponent} from './components/bw-graph/bw-graph-end-to-end/bw-graph-end-to-end.component';
import {
  ManageInvoiceRecipientsComponent
} from './components/manage-invoice-recipients/manage-invoice-recipients.component';
import {ViewAnnouncementComponent} from './components/view-announcement/view-announcement.component';
import {
  MarketDataQrdMlrLatencyComponent
} from './components/bw-graph/market-data-qrd-mlr-latency/market-data-qrd-mlr-latency.component';
import {
  MarketDataPlrLatencyGraphComponent
} from './components/bw-graph/market-data-plr-latency-graph/market-data-plr-latency-graph.component';
import {TimeSyncComponent} from './components/time-sync/time-sync.component';
import {TimeSyncMqttComponent} from './components/time-sync-mqtt/time-sync-mqtt.component';
import {TimeSyncProfileComponent} from './components/time-sync-profile/time-sync-profile.component';
import {
  MarketDataQfdMlrLatencyComponent
} from './components/bw-graph/market-data-qfd-mlr-latency/market-data-qfd-mlr-latency.component';
import {
  AssignmentListComponent
} from './hosting-manager/components/assignment/assignment-list/assignment-list.component';
import {
  MarketDataQhfPlrLatencyGraphComponent
} from './components/bw-graph/market-data-qhf-plr-latency-graph/market-data-qhf-plr-latency-graph.component';
import {
  AssignmentDetailsComponent
} from './hosting-manager/components/assignment/assignment-details/assignment-details.component';
import {MarketDataLedgersComponent} from './components/market-data-ledgers/market-data-ledgers.component';
import {CryptoMonitoringComponent} from './components/crypto_monitoring/crypto-monitoring.component';
import {
  ServiceDeliveryLocationsShellComponent
} from './components/service-delivery-locations/service-delivery-locations-shell.component';
import {
  SendEmergencyAnnouncementComponent
} from './components/send-emergency-announcement/send-emergency-announcement.component';
import {CartComponent} from './components/cart/cart.component';
import {CartConfirmationComponent} from './components/cart/cart-confirmation/cart-confirmation.component';
import {AuditTrailComponent} from './components/audit-trail/audit-trail.component';

export function newsProfileMatcher(segments: UrlSegment[]) {
  return segments.length === 3 && segments[1].path === 'quincyClientProfile' && segments[2].path === 'news'
    ? {consumed: segments, posParams: {companyUniqId: segments[0], service: segments[2]}}
    : null;
}

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    data: {tabTitle: 'Home'}
  },
  {
    path: 'audit-trail',
    component: AuditTrailComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Audit trail',
      tabTitle: 'Audit trail',
      expectedPermissions: ['canAccessAuditTrail'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent,
    canActivate: [AuthGuard],
    data: {expectedPermissions: ['mustChangePassword'], tabTitle: 'Change password'}
  },
  {
    path: 'market-data-plr-latency',
    component: MarketDataPlrLatencyGraphComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Market data PLR & Latency',
      tabTitle: 'Market data PLR & Latency',
      expectedPermissions: ['canAccessPlrLatencyGraphs'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'market-data-qhf-plr-latency-graph',
    component: MarketDataQhfPlrLatencyGraphComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Volume Signals: PLR&Lat graphs',
      tabTitle: 'Volume Signals: PLR&Lat graphs',
      expectedPermissions: ['canAccessPlrLatencyGraphs'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'market-data-qrd-mlr-latency',
    component: MarketDataQrdMlrLatencyComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Raw: MLR & Lat graphs',
      tabTitle: 'Raw: MLR & Lat graphs',
      expectedPermissions: ['canAccessQrdMlrLatencyGraphs'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'market-data-qfd-mlr-latency',
    component: MarketDataQfdMlrLatencyComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Price & Volume Signals: MLR & Lat graphs',
      tabTitle: 'Price & Volume Signals: MLR & Lat graphs',
      expectedPermissions: ['canAccessQfdMlrLatencyGraphs'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'loa',
    component: LoaComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Cross-connects and LOAs',
      tabTitle: 'Cross-connects and LOAs',
      expectedPermissions: ['canAccessLoas'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'service-delivery-locations',
    component: ServiceDeliveryLocationsShellComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Service delivery locations',
      tabTitle: 'Service delivery locations',
      expectedPermissions: ['canAccessCommercialPops'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'cart',
    component: CartComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Cart',
      tabTitle: 'Cart',
      expectedPermissions: ['canAccessCommercialPops'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'cart/confirmation',
    component: CartConfirmationComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Order confirmation',
      tabTitle: 'Order confirmation',
      expectedPermissions: ['canAccessCommercialPops'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'market-data-ledgers',
    component: MarketDataLedgersComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Ledger of Additional Data Distribution Points',
      tabTitle: 'Ledger of Additional Data Distribution Points',
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'loa/:companySugarUuid',
    component: LoaComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'LOAs',
      tabTitle: 'LOAs',
      expectedPermissions: ['canAccessLoas'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'encryption-keys',
    component: EncryptionKeysComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Encryption Keys',
      tabTitle: 'Encryption Keys',
      expectedPermissions: ['canAccessEncryptionKeys'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'encryption-keys-logs',
    component: EncryptionKeysLogsComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Encryption Keys Logs',
      tabTitle: 'Encryption Keys Logs',
      expectedPermissions: ['canAccessEncryptionKeysLogs'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'bandwidth-graphs',
    component: BwGraphEndToEndComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Bandwidth end-to-end graphs',
      tabTitle: 'Bandwidth end-to-end graphs',
      expectedPermissions: ['canListSchedules'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin', 'isCompanyVendor']
    }
  },
  // {
  //   path: 'connections-counters-live',
  //   component: ConnectionsCountersLiveComponent,
  //   canActivate: [AuthGuard],
  //   data: {
  //     title: 'Network port statistics',
  //     expectedPermissions: ['canAccessAwsPage'],
  //     unexpectedPermissions: ['mustChangePassword', 'isCompanyVendor']
  //   }
  // },
  {
    path: 'etrees-counters-live',
    component: EtreesCountersLiveComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Network E-Trees statistics',
      tabTitle: 'Network E-Trees statistics',
      expectedPermissions: ['canAccessAwsPage'],
      unexpectedPermissions: ['mustChangePassword', 'isCompanyVendor']
    }
  },
  {
    path: 'counters-mqtt',
    component: CountersMqttComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Network counters through MQTT',
      tabTitle: 'Network counters through MQTT',
      expectedPermissions: ['canActivateMqttCounters'],
      unexpectedPermissions: ['mustChangePassword', 'isCompanyVendor']
    }
  },
  // {
  //   path: 'connections-counters-live',
  //   component: ConnectionsCountersLiveComponent,
  //   canActivate: [AuthGuard],
  //   data: {
  //     title: 'Network port statistics',
  //     expectedPermissions: ['canAccessAwsPage'],
  //     unexpectedPermissions: ['mustChangePassword', 'isCompanyVendor']
  //   }
  // },
  {
    path: 'bandwidth-monitoring',
    component: BwGraphListComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'BW Monitoring strategies',
      tabTitle: 'BW Monitoring strategies',
      expectedPermissions: ['isMckayAdminOrMckaySuper'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: '404',
    component: PageNotFoundComponent,
    data: {title: 'Page not found', tabTitle: 'Not Found'}
  },
  {
    path: 'impersonate-user',
    component: ImpersonateUserComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Impersonate User',
      tabTitle: 'Impersonate User',
      expectedPermissions: ['isMckayAdminOrMckaySuper'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'commercial-pop',
    component: PopTrigramComponent,
    canActivate: [AuthGuard],
    data: {
      tabTitle: 'Commercial Pop',
      expectedPermissions: ['canAccessCommercialPops'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'weather-map/:region',
    component: WeatherMapComponent,
    canActivate: [AuthGuard],
    data: {
      tabTitle: 'Weather Map',
      expectedPermissions: ['canSeeWeatherMapSection'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'qed-symbols',
    component: QedSymbolDataComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Snapshot: symbols',
      tabTitle: 'Snapshot: symbols',
      expectedPermissions: ['canAccessSymbolsMulticast'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'qfd-symbols',
    component: QedSymbolDataComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Price & Volume: symbols',
      tabTitle: 'Price & Volume: symbols',
      expectedPermissions: ['canAccessSymbolsMulticast'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'qhf-symbols',
    component: QedSymbolDataComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Volume Signals (QHF): symbols',
      tabTitle: 'Volume Signals (QHF): symbols',
      expectedPermissions: ['canAccessSymbolsMulticast', 'canSeeQhfSection'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin'],
      qhfOnly: true
    }
  },
  {
    path: 'qhf-symbols/multicast',
    component: QedMulticastListComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Volume Signals (QHF): multicasts',
      tabTitle: 'Volume Signals (QHF): multicasts',
      expectedPermissions: ['canAccessSymbolsMulticast', 'canSeeQhfSection'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin'],
      qhfOnly: true
    }
  },
  {
    path: 'time-sync',
    component: TimeSyncComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'PTE monitoring page',
      tabTitle: 'PTE monitoring page',
      expectedPermissions: ['canAccessTimeSyncMonitoring'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'crypto-monitoring',
    component: CryptoMonitoringComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Crypto service monitoring',
      tabTitle: 'Crypto service monitoring',
      expectedPermissions: ['canAccessCryptoMonitoring'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'time-sync-mqtt',
    component: TimeSyncMqttComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'PTE monitoring through MQTT',
      tabTitle: 'PTE monitoring through MQTT',
      expectedPermissions: ['canAccessTimeSyncMonitoring'],
      unexpectedPermissions: ['mustChangePassword', 'isCompanyVendor']
    }
  },
  {
    path: 'schedules',
    component: BwSchedulesComponent,
    canActivate: [AuthGuard],
    data: {
      expectedPermissions: ['canListSchedules'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin'],
      tabTitle: 'Schedules'
    }
  },
  {
    path: 'schedules/:companySugarUuid',
    component: BwSchedulesComponent,
    canActivate: [AuthGuard],
    data: {
      expectedPermissions: ['canListSchedules'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin'],
      tabTitle: 'Schedules'
    }
  },
  {
    path: 'quincy-etrees',
    component: QuincyEtreesListComponent,
    canActivate: [AuthGuard],
    data: {
      expectedPermissions: ['canListQuincyEtrees'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin'],
      tabTitle: 'Quincy Etrees'
    }
  },
  {
    path: 'clf-ledger',
    component: ClfLedgerComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Ledger of Local Fiber E-Trees',
      tabTitle: 'Ledger of Local Fiber E-Trees',
      expectedPermissions: ['canAccessEtreeLedger'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: ':currentCompanyUniqId/encryption-keys',
    component: AdminEncryptionKeysComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Encryption keys',
      tabTitle: 'Encryption keys',
      expectedPermissions: ['canAccessAdminEncryptionKeys'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'email-confirmation/:token',
    component: EmailChangeConfirmationComponent,
    data: {tabTitle: 'Change Email'}
  },
  {
    path: 'mckay/:admin',
    component: HomeComponent,
    canActivate: [AuthGuard],
    data: {
      expectedRoles: ['ROLE_MCKAY'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin'],
      tabTitle: 'Home'
    }
  },
  {
    path: 'client/:currentCompanyUniqId',
    component: HomeComponent,
    canActivate: [AuthGuard],
    data: {
      expectedRoles: ['ROLE_CLIENT'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin'],
      tabTitle: 'Home'
    }
  },
  {
    path: 'reset-password/:token',
    component: ResetPasswordComponent,
    data: {tabTitle: 'Reset Password'}
  },
  {
    path: 'new-user-confirmation/:token',
    component: ResetPasswordComponent,
    data: {tabTitle: 'Reset Password'}
  },
  {
    path: 'qed-symbols/multicast',
    component: QedMulticastListComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Snapshot: multicasts',
      tabTitle: 'Snapshot: multicasts',
      expectedPermissions: ['canAccessSymbolsMulticast'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'qrd-symbols',
    component: QrdSymbolDataComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'QRD Symbol list',
      tabTitle: 'QRD Symbol list',
      expectedPermissions: ['canAccessSymbolsMulticast'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: ':currentCompanyUniqId/qrd-symbols',
    component: QrdSymbolDataComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'QRD Symbol list',
      tabTitle: 'QRD Symbol list',
      expectedPermissions: ['canAccessSymbolsMulticast'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: ':currentCompanyUniqId/download-log',
    component: DownloadLogComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Download Log',
      tabTitle: 'Download Log',
      expectedPermissions: ['canAccessDownloadsLog'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'document/:actionName',
    component: DocumentCrudComponent,
    canActivate: [AuthGuard],
    data: {
      expectedRoles: ['ROLE_MCKAY'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin'],
      tabTitle: 'Document'
    }
  },
  {
    path: 'document/:documentUniqid/download',
    component: DownloadDocumentComponent,
    data: {unexpectedPermissions: ['mustChangePassword', 'incompleteLogin'], tabTitle: 'Download Document'}
  },
  {
    path: 'view-announcement/:uuid',
    component: ViewAnnouncementComponent,
    data: {unexpectedPermissions: ['mustChangePassword', 'incompleteLogin'], tabTitle: 'View Announcement'}
  },
  {
    path: 'document/:documentUniqid/:actionName',
    component: DocumentCrudComponent,
    canActivate: [AuthGuard],
    data: {
      expectedRoles: ['ROLE_MCKAY'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin'],
      tabTitle: 'Document'
    }
  },
  {
    path: 'document',
    component: DocumentsComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Documents',
      tabTitle: 'Documents',
      expectedPermissions: ['canAccessDownloads'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'emergency-announcement',
    component: SendEmergencyAnnouncementComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Emergency Announcement',
      tabTitle: 'Emergency Announcement',
      expectedRoles: ['ROLE_MCKAY_SUPER', 'ROLE_MCKAY_ADMIN'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  // TODO check access
  {
    path: ':currentCompanyUniqId/qrd-products',
    component: QrdProductInformationComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Raw: products information',
      tabTitle: 'Raw: products information',
      expectedPermissions: ['canAccessProductInformation'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'qrd-symbols/multicast',
    component: QrdMulticastListComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Raw: multicasts',
      tabTitle: 'Raw: multicasts',
      expectedPermissions: ['canAccessSymbolsMulticast'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: ':currentCompanyUniqId/qrd-multicasts',
    component: QrdMulticastListComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Raw: multicasts',
      tabTitle: 'Raw: multicasts',
      expectedPermissions: ['canAccessSymbolsMulticast'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'quincy-news-symbols',
    component: QrdSymbolDataComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Quincy News Symbol list',
      tabTitle: 'Quincy News Symbol list',
      expectedPermissions: ['canAccessNewsProfile'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin'],
      newsOnly: true
    }
  },
  {
    path: 'quincy-news-symbols/multicast',
    component: QrdMulticastListComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Quincy News: multicasts',
      tabTitle: 'Quincy News: multicasts',
      expectedPermissions: ['canAccessNewsProfile'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin'],
      newsOnly: true
    }
  },
  {
    path: ':currentCompanyUniqId/:companyUniqId/users',
    component: ListUsersComponent,
    canActivate: [AuthGuard],
    data: {
      expectedPermissions: ['canListUsers'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin'],
      tabTitle: 'List Users'
    }
  },
  {
    path: ':companyUniqId/manage-inv-recipient',
    component: ManageInvoiceRecipientsComponent,
    canActivate: [AuthGuard],
    data: {
      expectedPermissions: ['canManageInvoiceRecipients'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin'],
      tabTitle: 'Manage Invoice Recipients'
    }
  },
  {
    path: ':currentCompanyUniqId/company/:newAction',
    component: ClientCrudComponent,
    data: {
      expectedRoles: ['ROLE_MCKAY_SUPER', 'ROLE_MCKAY_ADMIN'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin'],
      tabTitle: 'Client'
    }
  },
  {
    path: ':currentCompanyUniqId/company/:companyUniqId/:action',
    component: ClientCrudComponent,
    data: {
      expectedRoles: ['ROLE_MCKAY'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin'],
      tabTitle: 'Client'
    }
  },
  {
    path: ':currentCompanyUniqId/company',
    component: ListClientsComponent,
    canActivate: [AuthGuard],
    data: {
      expectedRoles: ['ROLE_MCKAY'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin'],
      tabTitle: 'List Clients'
    }
  },
  {
    path: ':currentCompanyUniqId/history-request',
    component: RequestHistoricalDataComponent,
    canActivate: [AuthGuard],
    data: {
      expectedPermissions: ['canAccessHistoricalData'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin'],
      tabTitle: 'Request Historical Data'
    }
  },
  {
    path: 'historical-data-log',
    component: HistoricalDataRequestLogComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Historical BW-service data request log',
      tabTitle: 'Historical BW-service data request log',
      expectedRoles: ['ROLE_MCKAY_SUPER', 'ROLE_MCKAY_ADMIN', 'ROLE_MCKAY_OPERATIONS'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    matcher: newsProfileMatcher,
    component: QedProfileComponent,
    canActivate: [AuthGuard],
    data: {
      tabTitle: 'Quincy Client Profile',
      expectedPermissions: ['canAccessQedQrdQfdProfile', 'canAccessNewsProfile'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: ':companyUniqId/quincyClientProfile/:service',
    component: QedProfileComponent,
    canActivate: [AuthGuard],
    data: {
      tabTitle: 'Quincy Client Profile',
      expectedPermissions: ['canAccessQedQrdQfdProfile'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: ':companyUniqId/timeSyncProfile',
    component: TimeSyncProfileComponent,
    canActivate: [AuthGuard],
    data: {
      tabTitle: 'PTE Profile',
      expectedPermissions: ['canAccessTimeSyncProfile'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: ':companyUniqId/clientProfile/timeSyncProfile',
    component: TimeSyncProfileComponent,
    canActivate: [AuthGuard],
    data: {
      tabTitle: 'PTE Profile',
      expectedPermissions: ['canAccessTimeSyncProfile'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin'],
    }
  },
  {
    path: ':currentCompanyUniqId/announcementLog',
    component: AnnouncementLogComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Announcement log',
      tabTitle: 'Announcement log',
      expectedPermissions: ['canAccessAnnouncementLog'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: ':currentCompanyUniqId/symbolDataDownloadLog',
    component: SymbolDataDownloadLogComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Symbol data download log',
      tabTitle: 'Symbol data download log',
      expectedPermissions: ['canAccessSymbolDataDownloadLog'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: ':announcementId/listRecipients',
    component: ListRecipientsComponent,
    canActivate: [AuthGuard],
    data: {
      tabTitle: 'Symbol data download log',
      expectedPermissions: ['canAccessRecipients']
    }
  },
  {
    path: ':currentCompanyUniqId/announcement/:status/:documentUniqid',
    component: DocumentNotificationComponent,
    canActivate: [AuthGuard],
    data: {expectedRoles: ['ROLE_MCKAY'], tabTitle: 'Document Notification'}
  },
  {
    path: ':currentCompanyUniqId/:companyUniqId/:userUniqId/:action',
    component: UserCrudComponent,
    canActivate: [AuthGuard],
    data: {
      expectedPermissions: ['canEditYours'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin'],
      tabTitle: 'User'
    }
  },
  {
    path: 'schedule/etree/:id',
    component: BwEtreeOverviewComponent,
    canActivate: [AuthGuard],
    data: {
      expectedPermissions: ['canListSchedules'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin'],
      tabTitle: 'Bw Etree'
    }
  },

  {
    path: 'bandwidth-graphs/etree/:vvlanId',
    component: BwGraphEndToEndComponent,
    canActivate: [AuthGuard],
    data: {
      expectedPermissions: ['canListSchedules'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin'],
      tabTitle: 'Bw Graphs'
    }
  },
  {
    path: 'quincy-etree/:id',
    component: QuincyEtreeOverViewComponent,
    canActivate: [AuthGuard],
    data: {
      expectedRoles: ['ROLE_MCKAY'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin'],
      tabTitle: 'Quincy Etree'
    }
  },
  {
    path: 'exchanges',
    component: ListExchangesComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Exchange',
      tabTitle: 'Exchange',
      expectedRoles: ['ROLE_MCKAY_SUPER', 'ROLE_MCKAY_ADMIN', 'ROLE_MCKAY_DAD_REPORTER'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'dad-config/:action/:dadName',
    component: DadConfigCrudComponent,
    canActivate: [AuthGuard],
    data: {
      tabTitle: 'Dad Config',
      expectedRoles: ['ROLE_MCKAY_SUPER', 'ROLE_MCKAY_ADMIN'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'reporters',
    component: ListReportersComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'List Reporters',
      tabTitle: 'List Reporters',
      expectedRoles: ['ROLE_MCKAY_SUPER'], unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'dad-admin/:companyUniqid',
    component: DadAdminComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Dad Admin',
      tabTitle: 'Dad Admin',
      expectedPermissions: ['canAccessDad'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'dad-admin',
    component: DadAdminComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Dad Admin',
      tabTitle: 'Dad Admin',
      expectedPermissions: ['canAccessDad'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'dad-form/:dadUniqid',
    component: DadFormComponent,
    canActivate: [AuthGuard],
    data: {
      expectedPermissions: ['canAccessDad'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin'],
      tabTitle: 'Dad Form'
    }
  },
  {
    path: 'dad-form/:dadUniqid/:original',
    component: DadFormComponent,
    canActivate: [AuthGuard],
    data: {
      expectedPermissions: ['canAccessDad'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin'],
      tabTitle: 'Dad Form'
    }
  },
  {
    path: 'assignment/:id',
    component: AssignmentDetailsComponent,
    canActivate: [AuthGuard],
    data: {
      tabTitle: 'Assignment Details',
      expectedPermissions: ['canAccessWorkVisit'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'hosting',
    component: AssignmentListComponent,
    canActivate: [AuthGuard],
    data: {
      tabTitle: 'Hosting - Datacenter work visits history',
      expectedPermissions: ['canAccessWorkVisit'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'hosting/:id',
    component: AssignmentListComponent,
    canActivate: [AuthGuard],
    data: {
      tabTitle: 'Hosting - Datacenter work visits history',
      expectedPermissions: ['canAccessWorkVisit'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'work-visit/:action/:id',
    component: WorkVisitCrudComponent,
    canActivate: [AuthGuard],
    canDeactivate: [UnsavedChangesGuard],
    data: {
      tabTitle: 'Work Visit',
      expectedPermissions: ['canAccessWorkVisit'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: 'work-visit/:action',
    component: WorkVisitCrudComponent,
    canActivate: [AuthGuard],
    data: {
      tabTitle: 'Work Visit',
      expectedPermissions: ['canAccessWorkVisit'],
      unexpectedPermissions: ['mustChangePassword', 'incompleteLogin']
    }
  },
  {
    path: '**',
    title: 'Not Found',
    redirectTo: '/404'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      scrollOffset: [0, 56]
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
